import { render, staticRenderFns } from "./DropdownProductId.vue?vue&type=template&id=51138ce4&scoped=true&"
import script from "./DropdownProductId.vue?vue&type=script&lang=ts&"
export * from "./DropdownProductId.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownProductId.vue?vue&type=style&index=0&id=51138ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51138ce4",
  null
  
)

export default component.exports